import type { WithId } from "Interfaces";
import type { IndexSignature } from "@clintonelec/typescriptutils";

export type ErrorResult = {
	errors: ErrorType[];
};

export type ErrorType = {
	status: string;
	code?: string;
	source: { pointer: string };
	title: string;
	detail: string;
};

export type Resource = "hostnames" | "users" | "auth";

export enum ResourceType {
	USERS = "users",
	HOSTNAMES = "hostnames",
	AUTH = "auth"
}

export type BaseResource = WithId & {
	resource: Resource;
};

export type ApiData = {
	type?: ResourceType;
	id?: string;
};

export type WithApiData<Attributes> = {
	data: Partial<ApiResource<Attributes>>;
} & WithDeserializedData;

export type ApiResource<Attributes> = {
	type: ResourceType;
	id: string;
	attributes: Attributes;
} & WithId & WithDeserializedData;

export type WithLinks = {
	links: {
		self: string;
		first: string;
		last: string;
		prev: string;
		next: string;
	};
};

export type WithDeserializedData = {
	relationships?: Record<ResourceType, { data: ApiData[] }>;
	links?: {
		self: string;
		first: string;
		last: string;
		prev: string;
		next: string;
	};
	meta?: IndexSignature<unknown>;
};
